// The changelist server's per-request caps. The client splits larger sets
// to fit them, and the mock server enforces them, so both use these numbers.

/** Pull requests the server accepts in one `/api/attention/batch` request. */
export const ATTENTION_BATCH_MAX = 100;

/** Marks the server accepts in one marks PUT. */
export const MARKS_PER_PUT = 5000;
